import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

import { Dietitian } from '../../../../../../../../data/dietitian/domain/dietitian';
import { CodedFeature } from '../../../../../../../../data/dietitian/domain/subscription/coded_feature';
import { SubscriptionFeature } from '../../../../../../../../data/dietitian/domain/subscription/subscription_feature';
import { FeatureByCodePopupFacade } from './feature-by-code-popup.facade';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'msd-feature-by-code-popup',
  templateUrl: './feature-by-code-popup.component.html',
  styleUrls: ['./feature-by-code-popup.component.scss'],
  providers: [FeatureByCodePopupFacade],
})
export class FeatureByCodePopupComponent {
  @Input() dietitian: Dietitian;
  @Input() codedFeature: CodedFeature;
  @Output() onValidate = new EventEmitter<SubscriptionFeature>();
  code: string;
  error: string | undefined;

  constructor(
    private bsModalRef: BsModalRef,
    private facade: FeatureByCodePopupFacade,
  ) {
    // Nada
  }

  hideModal() {
    this.bsModalRef.hide();
  }

  enableValidate() {
    return !!this.code && this.code.length > 6;
  }

  async validate() {
    try {
      const response = await this.facade.subscribeCodedFeature(
        this.dietitian.id.toString(),
        this.codedFeature.id.toString(),
        this.code,
      );
      console.log('☢️ subscribeCodedFeature', response);
      if (response) {
        this.hideModal();
        this.onValidate.emit(response);
      } else {
        this.error = 'Le code est incorrect, veuillez essayer à nouveau.';
      }
    } catch (e: any) {
      console.error(e);
      this.error =
        "Une erreur s'est produite, veuillez essayer à nouveau ultérieurement.";
    }
  }
}
